package gr.tech.site.util

// Helper to reformat date
fun reformatDate(isoDate: String): String {
    // ISO format is YYYY-MM-DD
    val parts = isoDate.split("-")
    return if (parts.size == 3) {
        "${parts[1]}/${parts[2]}/${parts[0]}" // MM/DD/YYYY
    } else {
        ""
    }
}